import request from 'src/api'
import moment from 'moment-timezone' // https://momentjs.com/
import { addToast } from 'src/toasts'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { showGoogleMap } from 'src/googleMap'
import initHistoryLoadMore from 'src/historyLoadMore'

function clientFunctions() {
  initHistoryLoadMore()

  // 🔑 **This function has TWO call sites, and the namespace is what makes a second invocation harmless.**
  // `packs/application.js:288` calls it for every ADMIN on every desktop page (the client-settings offcanvas
  // is reachable from the sidebar anywhere); `packs/clients/index.js:11` calls it again on the clients index.
  // The binding at `.add_client_contact_person, .add_email_recipient, .add_business_unit, …` **appends a
  // row**, so a double invocation appends two — the fault `spec/features/normal/customer/double_init_spec.rb`
  // was written for.
  //
  // ⚠️ **It does NOT double-run today, and `/simplify` reported that it did — the claim was checked and is
  // false.** Three independent facts stop it, and losing ANY ONE of them creates the bug:
  //   1. `ClientsController` is `super_admin_only` except `client_companies`, so an ADMIN cannot reach
  //      `/clients` at all;
  //   2. `#nav-clients` renders only `if is_super_admin`, so an ADMIN never sees the link;
  //   3. `isRole` is an EXACT match (`currentUserRole() === role`, `src/misc.js:50`), so a SUPER_ADMIN —
  //      the one role that CAN open `/clients` — does not get the `application.js` call.
  // 🚨 **So the obvious tidy-up is the dangerous one.** The natural next change is "widen `isRole('ADMIN')`
  // to include SUPER_ADMIN and drop the duplicate call" — and the widening alone, without the drop, is
  // exactly fact 3 removed. That is why this guard is here **before** anyone needs it rather than after.
  // Namespaced pre-emptively 2026-10-12.
  // 📌 **One hoisted `off('.clientFunctions')`, not an `off()` before each `on()`** — `off('.ns')` with no
  // event type clears every event in the namespace at once, while repeating the paired form would make each
  // `off` wipe the ten before it and leave only the last handler attached. `CLAUDE.md` → *Pack
  // Initialisation* has the rule; `packs/customers/functions_contact_person.js` is the other example.
  // ⚠️ Per navigation is automatic: Turbolinks replaces `<body>`, so `#offcanvasRight` is a fresh node each
  // visit and this is a no-op there. It is the SECOND call within one navigation that it exists for.
  $('#offcanvasRight').off('.clientFunctions')

  // jos avattu uuteen välilehteen
  if ($('#edit_client_id').length) {
    offcanvasRight.show()
    $.getScript('/clients/' + $('#edit_client_id').val() + '/basic_informations/edit')
  }

  $('#offcanvasRight').on('click.clientFunctions', '.remove_client_contact_person_row', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      dirty = true

      $(this).prev('input[type=hidden]').val('1')
      $(this).closest('.row').addClass('d-none')
      $(this).closest('.contact_person_rows').find('.row').not('.d-none').last().find('.hr').addClass('d-none')

      return event.preventDefault()
    }
  })
  
  $('#offcanvasRight').on('change.clientFunctions', '.client_contact_person_rows .select_main_contact', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      if ($(this).is(':checked')) {
        $('#contact-people .select_main_contact').prop('checked', false)
        $('#contact-people .contact_person_rows .remove_contact_person_row').removeClass('d-none')
      }
      $(this).prop('checked', true)
      $(this).closest('.contact_person').find('.remove_contact_person_row').addClass('d-none')
    }
  })

  $('#offcanvasRight').on('click.clientFunctions', '#change_language_fi, #change_language_ee', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      if (!dirty) {
        lockButton($(this))
        const url = $('#service-description-options-link button').data('link') + '?country=' + $(this).data('country')
        $.getScript(url)
      } else {
        confirmDirtyNav()
      }
    }
  })

  $('#offcanvasRight').on('click.clientFunctions', '#change_audit_country_fi, #change_audit_country_ee', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      if (!dirty) {
        lockButton($(this))
        const url = $('#audit-amounts-link button').data('link') + '?country=' + $(this).data('country')
        $.getScript(url)
      } else {
        confirmDirtyNav()
      }
    }
  })

  $('#offcanvasRight').on('click.clientFunctions', '.add_client_contact_person, .add_email_recipient, .add_business_unit, .add_service_description_option, .add_service_description_option_floor, .add_carpet_option, .add_sanitary_fitting_option, .add_client_company, .add_client_attachment, .add_contract_period, .add_audit_amount, .add_rating', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      dirty = true

      var regexp, time
      time = new Date().getTime()
      regexp = new RegExp($(this).data('id'), 'g')
      if ($(this).hasClass('add_client_contact_person')) {
        $(this).closest('.tab-pane').find('.client_contact_person_rows').append($(this).data('fields').replace(regexp, time))
        if ($(this).closest('.tab-pane').find('.client_contact_person_rows .contact_person:not(.d-none)').length === 1) {
          $(this).closest('.tab-pane').find('.client_contact_person_rows .contact_person').last().find('.select_main_contact').prop('checked', true)
        }
      } else if ($(this).hasClass('add_email_recipient')) {
        $(this).closest('.tab-pane').find('.email_recipient_rows').prepend($(this).data('fields').replace(regexp, time))
      } else if ($(this).hasClass('add_business_unit')) {
        $(this).closest('.tab-pane').find('.business_unit_rows').prepend($(this).data('fields').replace(regexp, time))
      } else if ($(this).hasClass('add_service_description_option')) {
        $(this).closest('.tab-pane').find('.service_description_option_rows').prepend($(this).data('fields').replace(regexp, time))
        const country = $(this).data('country')
        $(this).closest('.tab-pane').find('.service_description_option_rows .service_description_option_row').first().find('input[id*="country"]').val(country)
      } else if ($(this).hasClass('add_service_description_option_floor')) {
        $(this).closest('.tab-pane').find('.service_description_option_floor_rows').prepend($(this).data('fields').replace(regexp, time))
        const country = $(this).data('country')
        $(this).closest('.tab-pane').find('.service_description_option_floor_rows .service_description_option_floor_row').first().find('input[id*="country"]').val(country)
      } else if ($(this).hasClass('add_audit_amount')) {
        $(this).closest('.tab-pane').find('.audit_amount_rows').prepend($(this).data('fields').replace(regexp, time))
        const country = $(this).data('country')
        $(this).closest('.tab-pane').find('.audit_amount_rows .audit_amount_row').first().find('input[id*="country"]').val(country)
      } else if ($(this).hasClass('add_carpet_option')) {
        $(this).closest('.tab-pane').find('.carpet_option_rows').prepend($(this).data('fields').replace(regexp, time))
      } else if ($(this).hasClass('add_contract_period')) {
        $(this).closest('.tab-pane').find('.contract_period_rows').prepend($(this).data('fields').replace(regexp, time))
      } else if ($(this).hasClass('add_sanitary_fitting_option')) {
        $(this).closest('.tab-pane').find('.sanitary_fitting_option_rows').prepend($(this).data('fields').replace(regexp, time))
      } else if ($(this).hasClass('add_client_company')) {
        $(this).closest('.tab-pane').find('.client_company_rows').prepend($(this).data('fields').replace(regexp, time))
      } else if ($(this).hasClass('add_client_attachment')) {
        $(this).closest('.tab-pane').find('.attachment_rows').append($(this).data('fields').replace(regexp, time))
      } else if ($(this).hasClass('add_rating')) {
        $(this).closest('.tab-pane').find('.rating_rows').prepend($(this).data('fields').replace(regexp, time))
      }

      $(this).blur()

      return event.preventDefault()
    }
  })

  $('#offcanvasRight').on('click.clientFunctions', '.remove-record', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      dirty = true

      $(this).prev('input[type=hidden]').val('1')
      $(this).closest('.row').addClass('d-none')
      $(this).closest('.right-details').find('.row').not('.d-none').last().find('.hr').addClass('d-none')

      return event.preventDefault()
    }
  })

  $('#offcanvasRight').on('change.clientFunctions', '#client_country', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      if ($(this).val() === 'FINLAND') {
        $('.billing_information').removeClass('d-none')
      } else {
        $('.billing_information').addClass('d-none')
      }
    }
  })

  $('#offcanvasRight').on('change.clientFunctions', '.client_select_customer_contact_person', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      const id = $(this).val()
      const tab = $("#offcanvasRight .tab-pane.active").attr('id')
      
      const $cp = $(this).closest('.contact_person')
      if (id) {
        lockButton(event.currentTarget)

        const clientId = $("#mainForm").attr('action').split('/')[2]
        request.get(`/clients/${clientId}/contact_people/${id}`)
          .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
          .accept('json')
          .then(res => {
            $cp.find('input[name*="first_name"]').val(res.body.first_name).prop("disabled", res.body.deleted)
            $cp.find('input[name*="last_name"]').val(res.body.last_name).prop("disabled", res.body.deleted)
            $cp.find('input[name*="phone"]').val(res.body.phone).prop("disabled", res.body.deleted)
            $cp.find('input[name*="email"]').val(res.body.email).prop("disabled", res.body.deleted)
            $cp.find('input[name*="title"]').val(res.body.title).prop("disabled", res.body.deleted)

            unlockButton(event.currentTarget)
          })
          .catch(err => {
            handleErrors(err, event.currentTarget)
          })
      } else {
        $cp.find('input[name*="first_name"]').val('').prop("disabled", false)
        $cp.find('input[name*="last_name"]').val('').prop("disabled", false)
        $cp.find('input[name*="phone"]').val('').prop("disabled", false)
        $cp.find('input[name*="email"]').val('').prop("disabled", false)
        $cp.find('input[name*="title"]').val('').prop("disabled", false)
      }
    }
  })

  $('#offcanvasRight').on('click.clientFunctions', '.send-mail', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      lockButton(this)
      let recipient = ''
      let first_name = $(this).closest('.row').find('input[name*="first_name"]').first().val().trim()
      let last_name = $(this).closest('.row').find('input[name*="last_name"]').first().val().trim()
      let email = $(this).closest('.row').find('input[name*="email"]').first().val().trim()
      if (email.length) {
        email = '<' + email + '>'
      }
      recipient = [first_name, last_name, email].join(' ').trim()

      let dynamicLink = $('<a>', {
        href: "mailto:" + recipient,
        css: { display: 'none' }
      })

      $('body').append(dynamicLink)
      dynamicLink[0].click()
      dynamicLink.remove()

      unlockButton(this)
    }
  })

  $('#offcanvasRight').on('click.clientFunctions', '#client_einvoicing_data', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      lockButton('#einvoicing_data')

      const businessId = $('#client_business_id').val().trim()
      const country = $('#client_country').find(':selected').val()
      if (!validateBusinessId(businessId, country)) {
        addToast(I18n.t("errors.wrong_business_id"), 'error')
        unlockButton('#einvoicing_data')
      } else {
        request.get('https://avoindata.prh.fi/opendata-ytj-api/v3/companies?businessId=' + businessId)
          .accept('json')
          .then(res => {
            if (res.body.companies && res.body.companies.length > 0) {
              let company = res.body.companies[0]
              let names1 = company.names.filter(obj => {
                return parseInt(obj.type) === 1
              })
              if (names1.length) {
                let name1 = names1.sort((a,b) => Date.parse(b.registrationDate) - Date.parse(a.registrationDate))[0]
                if (name1) {
                  $('#client_billing_name1').val(name1.name)
                  if (!$('#client_company_name').val().trim().length) {
                    $('#client_company_name').val(name1.name)
                  }
                }
              }
              let names2 = company.names.filter(obj => {
                return parseInt(obj.type) === 3
              })
              if (names2.length) {
                let name2 = names2.sort((a,b) => Date.parse(b.registrationDate) - Date.parse(a.registrationDate))[0]
                if (name2) {
                  $('#client_billing_name2').val(name2.name)
                }
              }

              let addresses = company.addresses.filter(obj => {
                return parseInt(obj.type) === 1
              })
              let billingAaddresses = company.addresses.filter(obj => {
                return parseInt(obj.type) === 2
              })

              if (addresses.length || billingAaddresses.length) {
                let ada = addresses
                if (!ada.length) {
                   ada = billingAaddresses
                }
                let adb = billingAaddresses
                if (!adb.length) {
                   adb = addresses
                }

                let address1 = ada.sort((a,b) => Date.parse(b.registrationDate) - Date.parse(a.registrationDate))[0]
                let address2 = adb.sort((a,b) => Date.parse(b.registrationDate) - Date.parse(a.registrationDate))[0]
                let postOffice1 = address1.postOffices.filter(obj => {
                  return parseInt(obj.languageCode) === 1
                })[0]
                let postOffice2 = address2.postOffices.filter(obj => {
                  return parseInt(obj.languageCode) === 1
                })[0]
                let addr = ''
                if (postOffice1) {
                  addr = ''
                  if (address1.street) {
                    addr = address1.street
                    if (address1.buildingNumber) {
                      addr += ' ' + address1.buildingNumber
                    }
                    if (address1.entrance) {
                      addr += ' ' + address1.entrance
                    }
                    if (address1.apartmentNumber) {
                      addr += ' ' + address1.apartmentNumber
                    }
                  } else if (address1.postOfficeBox) {
                    addr = 'PL ' + address1.postOfficeBox
                  }
                  if (address1.co) {
                    addr = address1.co + ', ' + addr
                  }
                  if (!$('#client_street_name').val().trim().length) {
                    $('#client_street_name').val(addr)
                  }
                  if (!$('#client_post_code').val().trim().length) {
                    $('#client_post_code').val(address1.postCode)
                  }
                  if (!$('#client_town').val().trim().length) {
                    $('#client_town').val(postOffice1.city)
                  }
                }
                if (postOffice2) {
                  addr = ''
                  if (address2.street) {
                    addr = address2.street
                    if (address2.buildingNumber) {
                      addr += ' ' + address2.buildingNumber
                    }
                    if (address2.entrance) {
                      addr += ' ' + address2.entrance
                    }
                    if (address2.apartmentNumber) {
                      addr += ' ' + address2.apartmentNumber
                    }
                  } else if (address2.postOfficeBox) {
                    addr = 'PL ' + address2.postOfficeBox
                  }
                  if (address2.co) {
                    addr = address2.co + ', ' + addr
                  }
                  $('#client_billing_street_name').val(addr)
                  $('#client_billing_post_code').val(address2.postCode)
                  $('#client_billing_town').val(postOffice2.city)
                } else {
                  $('#client_billing_street_name').val('')
                  $('#client_billing_post_code').val('')
                  $('#client_billing_town').val('')
                }
              }
            } else {
              addToast(I18n.t("errors.not_found_ytj"), 'alert')
              $('#client_billing_name1').val('')
              $('#client_billing_name2').val('')
              $('#client_billing_street_name').val('')
              $('#client_billing_post_code').val('')
              $('#client_billing_town').val('')
              window.open('https://tietopalvelu.ytj.fi/yritys/' + businessId, '_blank')
            }

            unlockButton('#einvoicing_data')
          })
          .catch(err => {
            handleErrors(err, '#einvoicing_data')
          })

        request.get('/customers/einvoicing_data?business_id=' + businessId)
          .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
          .accept('json')
          .then(res => {
            if (res.body.operator) {
              $('#client_billing_einvoice_operator').val(res.body.operator).trigger('change')
              $('#client_billing_einvoice_address').val(res.body.address)
            } else {
              $('#client_billing_einvoice_operator').val('').trigger('change')
              $('#client_billing_einvoice_address').val('')
            }

            if (res.body.error0) {
              addToast(res.body.error0, 'alert')
            } else if (res.body.error1) {
              addToast(res.body.error1, 'alert')
              window.open('https://verkkolaskuosoite.fi/client/#/?searchText=' + businessId, '_blank')
            }
          })
          .catch(err => {
            handleErrors(err, null)
          })
      }
    }
  })

  $('#offcanvasRight').on('click.clientFunctions', '.client-show-googlemap', function(event) {
    if ($("#offcanvasRightHeaderNav ul.nav.nav-tabs").hasClass('clients')) {
      $(this).prop("disabled", true)

      const address = $('#client_street_name').val().trim()
      const postCode = $('#client_post_code').val().trim()
      const town = $('#client_town').val().trim()
      if (!address || !postCode || !town) {
        $(this).prop("disabled", false)
        addToast(I18n.t("errors.missing_address"), 'alert')
        return
      }
      const country = $('#client_country').val()
      const totalAddress = address + ", " + postCode + " " + town

      showGoogleMap(mainModal, totalAddress, [{ address: totalAddress + ", " + country }])

      $(this).prop("disabled", false)
    }
  })
}

function validateBusinessId(businessId, country) {
  if (country === 'ESTONIA') {
    if (businessId.length !== 8) {
      return false
    }
    if (!/^\d+$/.test(businessId)) {
      return false
    }
  } else if (country === 'FINLAND') {
    if (businessId.length !== 9) {
      return false
    }
    if (!/^\d{7}[-]\d{1}$/.test(businessId)) {
      return false
    }

    let total_count = 0
    const multipliers = [7, 9, 10, 5, 8, 4, 2]

    for(var i = 0; i < multipliers.length; i++) {
      total_count += multipliers[i] * parseInt(businessId[i])
    }

    let remainder = total_count % 11

    // Remainder 1 is not valid
    if (remainder === 1) {
      return false
    }

    // Remainder 0 leads into checksum 0
    if (remainder === 0) {
      if (parseInt(businessId.slice(-1)) !== 0) {
        return false
      } else {
        return true
      }
    }

    // If remainder is not 0, the checksum should be remainder deducted from 11
    if (parseInt(businessId.slice(-1)) !== 11 - remainder) {
      return false
    }
  }

  return true
}

export { clientFunctions }
